module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/870b8b39b077fc3423906a2e68b41245.png";